import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.onClick)
  }

  onClick = event => {
    event.stopPropagation()
    const tempInput = document.createElement('input')
    tempInput.value = event.target.dataset.text || event.target.innerText
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('toast', { detail: { message: 'Copied to clipboard!' } }))
    }, 900)
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick)
  }
}
